module.exports = __webpack_public_path__ + "static/media/loading.4dc3b47d.gif";